// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.setupContainer {
  display: grid;
}

.list-buttons {
  margin-bottom: 15px !important;
}

.row, .form-group {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.enrollment-tool-page .form-group {
  margin-bottom: 60px;
}
@media (max-width: 1024px) {
  .enrollment-tool-page .form-group {
    margin-bottom: 30px;
    margin-top: 40px;
  }
  .enrollment-tool-page .btn {
    padding: 0;
  }
  .enrollment-tool-page .btn-link {
    padding-top: 0;
  }
  .enrollment-tool-page .btn-cancel {
    margin: 20px 0 0;
  }
}

.remove-account {
  margin-top: 0px;
  margin-bottom: 20px;
  border-top: 1px solid #d2d2d2;
  padding-top: 20px;
}
.remove-account a {
  font-size: 1.4rem;
  line-height: 1.8rem;
}

.subLabelAndroid, .subLabelSamsung, .subLabelApple {
  font: 16px "Omnes-ATT-W02";
}

.selectedDetailsZtpsetup {
  padding-bottom: 20px;
}

.signup, .setup, .remove {
  opacity: 0;
  cursor: default;
}

.radioContainer .radio {
  cursor: default;
}

h1 {
  margin-top: 30px;
}
h1.enroll-tool-header {
  padding-left: -15px;
}
@media (max-width: 1024px) {
  h1.enroll-tool-header {
    padding-left: 15px;
  }
}

.setupContainer {
  margin-left: 10px;
  margin-bottom: 20px;
}

h2 {
  margin-bottom: 20px;
}

hr {
  margin-top: 30px;
  margin-bottom: 30px;
}

p {
  margin-bottom: 30px;
}

.help-accordion {
  border-bottom: 1px solid #d2d2d2;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.flex-container {
  display: flex;
}

.chart-container {
  margin: 0 20px;
  text-align: center;
}

.chart-legend-container {
  margin-left: 15px;
  width: 215px;
}

.chart-legends {
  margin-left: 15px;
  width: 290px;
}
.chart-legends .legend-container {
  min-height: 110px;
  margin-top: 20px;
}
.chart-legends .legend-container ul li {
  font-size: 14px !important;
}

.article {
  padding: 3px;
  margin-left: 15px;
}

.oemDetails {
  padding-left: 35px;
  font: 1.6rem "Omnes-ATT-W02";
}

.selectedDetailsZtp {
  padding-bottom: 20px;
}

.googleId, .samsungId {
  padding: 10px 0px 10px 0px;
  display: none;
}

.gtooltip, .stooltip {
  bottom: 25px;
  left: 343px !important;
  top: -29px !important;
}
@media only screen and (max-width: 507px) and (min-width: 449px) {
  .gtooltip, .stooltip {
    left: 294px !important;
  }
}
@media (max-width: 1024px) {
  .gtooltip, .stooltip {
    bottom: 25px;
    left: 209px !important;
    top: -29px !important;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .gtooltip, .stooltip {
    bottom: 0px;
    left: 295px !important;
  }
}

.helper-text {
  top: 0px;
  left: 75px;
}
@media (max-width: 1024px) {
  .helper-text {
    top: 34px !important;
    left: -29px;
  }
}
@media only screen and (max-width: 507px) and (min-width: 449px) {
  .helper-text {
    left: 32px !important;
  }
}
@media only screen and (max-width: 1025px) and (min-width: 508px) {
  .helper-text {
    left: 41px !important;
  }
}

.form-control {
  width: 380px;
}

@media (max-width: 1024px) {
  main {
    margin-left: 30px;
    margin-right: 30px;
  }
  .btn-cancel {
    margin: 20px 0;
    text-align: center;
    width: 100%;
  }
  .btn {
    text-align: center;
    width: 100%;
  }
  .form-control {
    width: inherit;
  }
  .flex-container {
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    flex-direction: column;
    border-right: 0;
    flex-direction: column;
    float: none;
    width: 100%;
  }
  .chart-legend-container {
    margin-left: 0;
    width: 100%;
  }
  .chart-legend-container .legend-container {
    margin-left: 10px;
    min-height: auto;
    margin-bottom: 20px;
    width: 100px;
  }
  .chart-legend-container .legend-container ul {
    margin: auto;
    max-width: 300px;
  }
  .chart-legend-container .legend-container li {
    display: inline-block;
    width: 130px;
  }
  .chart-legend-container .legend-container li:nth-child(odd) {
    margin-right: 25px;
    max-width: calc(50% - 25px);
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/cancel-participation/remove-account/remove-account.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,aAAA;AAmJF;;AAjJA;EACE,8BAAA;AAoJF;;AAjJA;EACE,2BAAA;EACA,4BAAA;AAoJF;;AA/IE;EACE,mBAAA;AAkJJ;AF3II;EEFA;IACE,mBAAA;IACA,gBAAA;EAgJJ;EA5IE;IACE,UAAA;EA8IJ;EA1IE;IACE,cAAA;EA4IJ;EAzIE;IACE,gBAAA;EA2IJ;AACF;;AAvIA;EACE,eAAA;EACA,mBAAA;EAKA,6BAAA;EACA,iBAAA;AAsIF;AA3IE;EACE,iBAAA;EACA,mBAAA;AA6IJ;;AAvIA;EACE,0BAAA;AA0IF;;AAvIA;EACE,oBAAA;AA0IF;;AAvIA;EACK,UAAA;EACA,eAAA;AA0IL;;AAxIA;EACK,eAAA;AA2IL;;AAxIA;EACE,gBAAA;AA2IF;AAzIE;EACE,mBAAA;AA2IJ;AF7LI;EEiDF;IAGI,kBAAA;EA6IJ;AACF;;AAzIA;EACE,iBAAA;EACA,mBAAA;AA4IF;;AAzIA;EACE,mBAAA;AA4IF;;AAzIA;EACE,gBAAA;EACA,mBAAA;AA4IF;;AA1IA;EACE,mBAAA;AA6IF;;AA1IA;EACE,gCAAA;EACA,oBAAA;EACA,mBAAA;AA6IF;;AA1IA;EAEE,aAAA;AA6IF;;AAzIA;EACE,cAAA;EACA,kBAAA;AA4IF;;AAzIA;EACE,iBAAA;EACA,YAAA;AA4IF;;AAvIA;EACE,iBAAA;EACA,YAAA;AA0IF;AAxII;EACI,iBAAA;EACA,gBAAA;AA0IR;AAvIU;EACE,0BAAA;AAyIZ;;AAlIA;EACE,YAAA;EACA,iBAAA;AAqIF;;AAlIA;EACE,kBAAA;EACA,4BAAA;AAqIF;;AAlIE;EACE,oBAAA;AAqIJ;;AAlIA;EACE,0BAAA;EACA,aAAA;AAqIF;;AAlIA;EACE,YAAA;EACA,sBAAA;EACA,qBAAA;AAqIF;AApIE;EAJF;IAKI,sBAAA;EAuIF;AACF;AFnRI;EEsIJ;IAQI,YAAA;IACA,sBAAA;IACA,qBAAA;EAyIF;AACF;AAxIE;EAZF;IAaI,WAAA;IACA,sBAAA;EA2IF;AACF;;AAvIA;EAEE,QAAA;EACA,UAAA;AAyIF;AFrSI;EEyJJ;IAKI,oBAAA;IACA,WAAA;EA2IF;AACF;AA1II;EARJ;IASM,qBAAA;EA6IJ;AACF;AA5IE;EAXF;IAaG,qBAAA;EA8ID;AACF;;AA3IA;EACE,YAAA;AA8IF;;AFzTI;EEgLF;IACE,iBAAA;IACA,kBAAA;EA6IF;EAzIA;IACE,cAAA;IACA,kBAAA;IACA,WAAA;EA2IF;EAxIA;IAEE,kBAAA;IACA,WAAA;EAyIF;EAvIA;IACE,cAAA;EAyIF;EAtIA;IFzLE,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IE4LA,eAAA;IACA,sBAAA;IACA,WAAA;IACA,WAAA;EA2IF;EAxID;IACG,cAAA;IACA,WAAA;EA0IF;EAvIE;IACE,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;EAyIJ;EAvII;IACE,YAAA;IACA,gBAAA;EAyIN;EAtII;IACE,qBAAA;IACA,YAAA;EAwIN;EAtIM;IACE,kBAAA;IACA,2BAAA;EAwIR;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.setupContainer{\n  display:grid;\n}\n.list-buttons{\n  margin-bottom:15px!important;\n}\n\n.row, .form-group {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n\n.enrollment-tool-page {\n  //font-family: 'ATTAleckSans-Regular' !important;\n  .form-group {\n    margin-bottom: 60px;\n    //font-family: 'ATTAleckSans-Regular' !important;\n  }\n\n  @include respond-to(small) {\n    .form-group {\n      margin-bottom: 30px;\n      margin-top: 40px;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n\n    .btn {\n      padding: 0;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n\n    .btn-link {\n      padding-top: 0;\n    }\n\n    .btn-cancel {\n      margin: 20px 0 0;\n    }\n  }\n}\n\n.remove-account {\n  margin-top: 0px;\n  margin-bottom: 20px;\n  a {\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n  }\n  border-top: 1px solid #d2d2d2;\n  padding-top: 20px;\n}\n\n.subLabelAndroid, .subLabelSamsung, .subLabelApple {\n  font: 16px 'Omnes-ATT-W02';\n  //font-family: 'ATTAleckSans-Regular' !important;\n}\n.selectedDetailsZtpsetup{\n  padding-bottom: 20px;\n}\n\n.signup,.setup,.remove{\n     opacity: 0;\n     cursor: default;\n}\n.radioContainer .radio{\n     cursor: default;\n}\n\nh1 {\n  margin-top: 30px;\n  //font-family: 'ATTAleckSans-Regular' !important;\n  &.enroll-tool-header {\n    padding-left: -15px;\n    @include respond-to(small) {\n      padding-left: 15px;           \n    }\n  }\n}\n\n.setupContainer {\n  margin-left: 10px;\n  margin-bottom: 20px;\n}\n\nh2 {\n  margin-bottom: 20px;\n}\n\nhr{\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\np {\n  margin-bottom: 30px;\n}\n\n.help-accordion{\n  border-bottom: 1px solid color(default, dark);\n  padding-bottom: 30px;\n  margin-bottom: 30px;\n}\n\n.flex-container {\n  display: -webkit-flex;\n  display: flex;\n  //float: left;\n}\n\n.chart-container {\n  margin: 0 20px;\n  text-align: center;\n}\n\n.chart-legend-container {\n  margin-left: 15px;\n  width: 215px;\n // margin-bottom: 20px;\n // border: 1px solid;\n}\n\n.chart-legends {\n  margin-left: 15px;\n  width: 290px;\n\n    .legend-container {\n        min-height: 110px;\n        margin-top: 20px;\n\n        ul {\n          li {\n            font-size: 14px !important;\n          }\n        }\n    }\n  \n}\n\n.article{\n  padding: 3px;\n  margin-left: 15px;\n}\n\n.oemDetails{\n  padding-left: 35px;\n  font: 1.6rem 'Omnes-ATT-W02';\n  }\n\n  .selectedDetailsZtp {\n    padding-bottom: 20px;\n  }  \n\n.googleId, .samsungId{  \n  padding: 10px 0px 10px 0px;\n  display: none;\n}\n\n.gtooltip, .stooltip{\n  bottom: 25px;\n  left:343px  !important;\n  top: -29px !important; \n  @media only screen and (max-width: 507px) and (min-width: 449px){\n    left: 294px  !important;\n   }  \n  @include respond-to(small) {\n    bottom: 25px;\n    left:209px  !important;\n    top: -29px !important; \n      }\n  @media only screen and (max-width: 1025px) and (min-width: 508px){\n    bottom: 0px;\n    left: 295px !important;\n  }\n}\n\n\n.helper-text{\n  // left:239px;\n  top: 0px;\n  left: 75px;\n  @include respond-to(small) {\n    top:34px !important;\n    left: -29px;\n    }\n    @media only screen and (max-width: 507px) and (min-width: 449px){\n      left: 32px  !important;\n     }  \n  @media only screen and (max-width: 1025px) and (min-width: 508px){\n   // bottom: 0px;\n   left: 41px !important;\n  }\n}\n\n.form-control{\n  width:380px;\n}\n\n@include respond-to(small) {\n   \n  main {\n    margin-left:30px;\n    margin-right:30px;\n    //font-family: 'ATTAleckSans-Regular' !important;\n\n  }\n  .btn-cancel {\n    margin: 20px 0;\n    text-align: center;\n    width: 100%;\n  }\n\n  .btn {\n    //font-family: 'ATTAleckSans-Regular' !important;\n    text-align: center;\n    width: 100%;\n  }\n  .form-control{\n    width:inherit;\n  }\n\n  .flex-container {\n    @include vendor-prefix('flex-direction', column);\n  \n    border-right: 0;\n    flex-direction: column;\n    float: none;\n    width: 100%;\n  }\n\n .chart-legend-container {\n    margin-left: 0;\n    width: 100%;\n    \n\n    .legend-container {\n      margin-left: 10px;\n      min-height: auto;\n      margin-bottom: 20px;\n      width: 100px;\n\n      ul {\n        margin: auto;\n        max-width: 300px;\n      }\n\n      li {\n        display: inline-block;\n        width: 130px;\n\n        &:nth-child(odd) {\n          margin-right: 25px;\n          max-width: calc(50% - 25px);\n        }\n\n      }\n    }\n  }\n}\n\n\n\n \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
